import { useEffect, useState } from 'react';

import ActionStatus from '../types/actionStatus';

/**
 * imageUrl 을 받아서 이미지 객체의 로딩 상태를 반환한다
 *
 * @param {string} imageUrl 이미지 url
 * @return {{status: ActionStatus}} image 로딩 상태를 담은 객체
 */
function useImageLoading(imageUrl: string) {
  const [image, setImage] = useState<{ status: ActionStatus }>({ status: ActionStatus.INITIAL });

  useEffect(() => {
    const img = new Image();

    if (imageUrl) {
      setImage({ status: ActionStatus.REQUEST });
      img.src = imageUrl;
    }

    img.onload = () => {
      setImage({ status: ActionStatus.SUCCESS });
    };

    img.onerror = () => {
      setImage({ status: ActionStatus.FAILURE });
    };
  }, [imageUrl]);

  return image;
}

export default useImageLoading;
